import posthog from 'posthog-js';
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import "./index.css";
import "../src/styles/custom.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

if (process.env.REACT_APP_POSTHOG_KEY) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: true,
  });
}

 const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 20,        // data is fresh for 20 minutes
      refetchOnMount: false,           // don't refetch on component remount
      refetchOnWindowFocus: false,     // don't refetch on tab/window focus                
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));

window.global = {
  // Deprecated local override — traffic uses src/api/base.js (REACT_APP_API_URL)
  server_url: process.env.REACT_APP_API_URL || "",
};

root.render(
  // <React.StrictMode>
  <BrowserRouter basename="/">
    <QueryClientProvider client={queryClient}>
    <App />
    </QueryClientProvider>
  </BrowserRouter>
  // </React.StrictMode>
);
